import { z } from "zod";

import { baseApiResponse } from "./BaseApiResponse";

export const userTournamentResolver = z.object({
	ID: z.string(),
	Series: z.string(),
	Name: z.string(),
	Description: z.string(),
	Terms: z.string(),
	Points: z.string(),
	PointsTotal: z.string(),
	WinnerBy: z.string(),
	Start: z.string(),
	End: z.string(),
	Status: z.string(),
	Place: z.string().nullable(),
	Win: z.string().nullable(),
	WinEUR: z.string(),
	FeeType: z.string(),
	FeeAmount: z.record(z.string()).or(z.string()),
	Qualification: z.string(),
	BetMin: z.object({
		RUB: z.string(),
		USD: z.string(),
		EUR: z.string()
	}),
	BetMax: z.object({
		RUB: z.string(),
		USD: z.string(),
		EUR: z.string()
	}),
	BetsCount: z.string(),
	WinsCount: z.string(),
	BetsAmount: z.string(),
	WinsAmount: z.string(),
	WinningSpreadCount: z.number(),
	Target: z.string(),
	WinToBetRatio: z.string(),
	BestWinToBetRatio: z.string(),
	IDBonus: z.string(),
	Image: z.string(),
	Image_promo: z.string(),
	Image_dashboard: z.string(),
	Image_description: z.string(),
	Image_other: z.string(),
	TotalWins: z.object({
		EUR: z.number().or(z.string()).nullable(),
		Currency: z.string().nullable()
	}),
	StatusText: z.string()
});

export type UserTournamentModel = z.infer<typeof userTournamentResolver>;

export const listUserTournamentsResult = baseApiResponse.extend({
	data: userTournamentResolver.array()
});

export type ListUserTournamentsResult = z.infer<typeof listUserTournamentsResult>;
